<template>
<div class="admin-account-edit flex w-full justify-start" style="flex-direction: column;">

  <div ref="adminAccountEditForm" style="height: calc(100vh - 210px); overflow-y: scroll; margin: 0 1rem;">

    <div style="margin: 1rem;" class="required aisea-text-16-400-black" >
      必要事項を入力してください。「<label></label>」は入力必須項目です。
    </div>

    <div v-if="inputParam.enterprise_account_id">

      <!-- ポップアップ型ではなく、アコーディオンで埋め込む -->
      <vs-collapse accordion style="padding: 0;" ref="avatarCollapse">
        <vs-collapse-item open not-arrow >  
          <!-- プロフィール画像 -->
          <div slot="header" id="collapse-header-avatar-area" style="width: 100%; padding: 0; height: 0;" ></div>
          <div style="position: relative;">
            <!-- プロフィール画像を変更する -->
            <vs-avatar
              :src="avatar"
              :text="avatarText"
              class="flex-shrink-0 mr-2"
              :color="AISEA_COLOR.BLUE"
              size="64px"
              icon="person_add_alt_1"
              @click="toggleCollapse"
              style="margin-top: 1rem;"
            />
            <div style="font-size: xx-small; position: absolute; bottom: 12px; left: 26px; " :style="{ color: AISEA_COLOR.WHITE, }">{{ avatar ? '編集' : '登録' }}</div>
          </div>
        </vs-collapse-item>
        <vs-collapse-item  not-arrow >  
          <!-- プロフィール画像を変更する -->
          <div slot="header" id="collapse-header-work-area" style="width: 100%; padding: 0; height: 0;" ></div>
          <div class="flex w-full justify-center">
            <!-- enterprise_crew_id を渡す必要があるので、新規では不可能 -->
            <embedded-upload-profile-image
              class="w-4/5"
              ref="dialogUploadProfileImage"
              @onImageUploaded="onImageUploaded"
              @onImageUploadCancel="onImageUploadCancel"
            ></embedded-upload-profile-image>
          </div>
        </vs-collapse-item>
      </vs-collapse>
    </div>

    <div class="flex w-full justify-start items-start admin-account-edit-form-row">
      <div class="w-full required">
        <vs-input
          class="w-full"
          label="氏名"
          v-model="localData.profile.name"
          v-validate="'required|regex:^[^\x20\u3000].*[^\x20\u3000]$|max:56'"
          name="name"
          data-vv-as="氏名"
          :color="AISEA_COLOR.BLUE"
        />
        <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
      </div>
    </div>

    <div class="flex w-full justify-start items-start admin-account-edit-form-row">
      <vs-input
        class="w-full required"
        label="氏名(カナ)"
        v-model="localData.profile.name_kana"
        v-validate="'required|regex:^[\u30A1-\u30FF\x20\u3000]+$|max:56'"
        name="name_kana"
        data-vv-as="氏名(カナ)"
        :color="AISEA_COLOR.BLUE"
      />
      <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('name_kana')">{{
        errors.first("name_kana")
      }}</span>
    </div>

    <div class="flex w-full justify-start items-start admin-account-edit-form-row">
      <vs-input
        class="w-full"
        label="部署"
        v-model="localData.profile.department"
        v-validate="'max:56'"
        name="department"
        data-vv-as="部署"
        :color="AISEA_COLOR.BLUE"
      />
      <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('department')">{{
        errors.first("department")
      }}</span>
    </div>

    <div class="flex w-full justify-start items-start admin-account-edit-form-row">
      <vs-input
        class="w-full"
        label="役職"
        v-model="localData.profile.title"
        v-validate="'max:56'"
        name="role_name"
        data-vv-as="役職"
        :color="AISEA_COLOR.BLUE"
      />
      <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('role_name')">{{
        errors.first("role_name")
      }}</span>
    </div>

    <div class="flex w-full justify-start items-start admin-account-edit-form-row">
      <div class="flex w-full justify-start items-center">

        <vs-input
          class="w-full"
          label="電話番号"
          v-model="localData.profile.phone_number"
          v-validate="'numeric|custom_phoneNumber'"
          name="phone_number"
          data-vv-as="電話番号"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
      <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('phone_number')">{{
        errors.first("phone_number")
      }}</span>
    </div>

    <div class="flex w-full justify-start items-start admin-account-edit-form-row">
      <div class="flex w-full justify-start items-center">
        <vs-input
          class="w-full"
          label="メールアドレス"
          v-model="localData.profile.email_address"
          name="email_address"
          :disabled="true"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
    </div>


  </div>


  <vs-divider style="margin: 0;" />

  <div class="flex w-full justify-end items-center">
    <div style="margin: 0.8rem;" >
      <vs-button type="flat" style="width: 6rem; padding: 0.4rem;" :style="{ 'background-color': AISEA_COLOR.WHITE, }" @click="onCancel" :color="AISEA_COLOR.GRAY" >キャンセル</vs-button>
    </div>    
    <div style="margin: 0.8rem;" >
      <vs-button style="width: 6rem; padding: 0.4rem;" @click="onSubmit" :disabled="( $refs.dialogUploadProfileImage && $refs.dialogUploadProfileImage.isCrop ) || !validateForm" :color="AISEA_COLOR.BLUE" >保存</vs-button>
    </div>    
  </div>

</div>
</template>

<script>
import Vue from "vue";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import { storage } from "@/firebase/firebaseConfig";
import EmbeddedUploadProfileImage from "./EmbeddedUploadProfileImage";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAdminAccountApi = AiseaApiFactory.get("enterpriseAdminAccount");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "AdminAccountEdit",
  components: {
    EmbeddedUploadProfileImage
  },
  mixins: [DatepickerMixin, DeviceInfoMixin, ColorMixin],
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data() {
    return {
      avatar: null,
      avatarText: "",
      localData: {
      },
      disabledDates: {
        from: new Date(),
      },
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.localData.profile && this.localData.profile.name  && this.localData.profile.name_kana;
    }
  },
  watch: {
    activeSidebarCrew(val) {
      if (val) {
        this.initLocalData();
        this.$validator.reset();
      }
    },
  },
  methods: {

    initLocalData() {
      this.avatar = null;
      this.avatarText = '';

      if ( this.inputParam.enterprise_account_id  ) {

        this.localData = JSON.parse(JSON.stringify(this.inputParam));
        if ( ! this.localData.profile ) {
          this.localData.profile = {};
        }

        console.debug("### localData", this.localData);

        // this.avatarText = this.inputParam.profile && this.inputParam.profile.name ? this.inputParam.profile.name.charAt( 0 ) : '';
        if ( this.inputParam.profile && this.inputParam.profile.picture ) {
          storage
            .child(this.inputParam.profile.picture.thumbnail_path)
            .getDownloadURL()
            .then(response => {
              this.avatar = response;
            });
        }

      } else {
        this.localData = { profile: {}, };
      }
    },

    toggleCollapse() {
      this.$el.querySelector('#collapse-header-work-area').click();
    },

    showDialogUpload() {
      this.$refs.dialogUploadProfileImage.show();
    },

    async onImageUploaded(pictureData) {
      this.toggleCollapse();
      this.localData.picture = pictureData.data;
      try {


        let payload = {
          "name": this.inputParam.profile.name,
          "name_kana": this.inputParam.profile.name_kana,
          "phone_number": this.inputParam.profile.phone_number,
          "title": this.inputParam.profile.title,
          "department": this.inputParam.profile.department,
          picture: { id: this.localData.picture.id },

        };
        const res = await enterpriseAdminAccountApi.update(this.inputParam.enterprise_account_id, payload);
        if ( res.status ) {
          this.$vs.notify({
            title: `陸上従業員基本情報設定`,
            text: `${this.localData.profile.name}の画像を更新しました。`,
            color: "success",
            icon: "done"
           });

          this.avatar = null;
          storage
            .child(this.localData.picture.thumbnail_path)
            .getDownloadURL()
            .then(response => {
              this.avatar = response;
            });
          this.$emit('reloadList');
        } else {
          this.$vs.notify({
            title: `陸上従業員基本情報設定`,
            text: `${this.localData.profile.name}の画像を更新できませんでした。`,
            color: "danger",
            icon: "done"
          });
        }
      } catch (e) {
        this.$vs.notify({
          title: `陸上従業員基本情報設定`,
          text: `${this.localData.profile.name}の画像を更新できませんでした。`,
          color: "danger",
          icon: "done"
        });
      }

      this.$el.querySelector('#collapse-header-avatar-area').click();
    },

    onImageUploadCancel() {
      this.$el.querySelector('#collapse-header-avatar-area').click();
    },

    onCancel() {
      this.localData = { profile: {}, };
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    async onSubmit() {
      let checkValidate = await this.$validator.validateAll();
      if ( !checkValidate ) {
        return false;
      }
      
      if ( this.inputParam.enterprise_account_id ) {
        let payload = {
          "name": this.localData.profile.name,
          "name_kana": this.localData.profile.name_kana,
          "phone_number": this.localData.profile.phone_number,
          "title": this.localData.profile.title,
          "department": this.localData.profile.department,
        };

        if(this.localData.picture) {
          payload.picture = { id: this.localData.picture.id };
        }

        console.debug("### 更新API payload", payload);

        try {

          this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
          const res = await enterpriseAdminAccountApi.update(this.inputParam.enterprise_account_id, payload);
          this.$vs.loading.close();

          if ( res.status ) {
            this.$vs.notify({
              title: `陸上従業員基本情報設定`,
              text: `${this.localData.profile.name}の基本情報を更新しました`,
              color: "success",
              iconPack: "feather",
              icon: "icon-check"
            });
          } else {
            Vue.$log.warn("error at enterpriseAdminAccountApi.update() ", this.inputParam.enterprise_account_id, payload, res);
            this.$vs.notify({
              title: `陸上従業員基本情報設定`,
              text: `${this.localData.profile.name}の基本情報を更新できませんでした`,
              color: "warning",
              iconPack: "feather",
              icon: "icon-check"
            });
          }

        } catch (e) {
          Vue.$log.warn("error at enterpriseAdminAccountApi.update() ", this.inputParam.enterprise_account_id, payload, e);
          this.$vs.notify({
            title: `陸上従業員基本情報設定`,
            text: `${this.localData.profile.name}の基本情報を更新できませんでした`,
            color: "warning",
            iconPack: "feather",
            icon: "icon-check"
          });
        }

      }

      this.$emit("updatedId", this.localData.enterprise_account_id);
      this.localData = { profile: {}, };

      this.$emit('reloadList');
      this.$emit('close');
    },
  },
  created() {
    this.initLocalData();
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.adminAccountEditForm.click();
    });
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.admin-account-edit {

  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger),1);
    }
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2.0rem;
    }
  }

  .admin-account-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right : 8px;
  }

  .vs__search::placeholder {
    color: $aisea-light-gray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  .vs-collapse-item {
    border-bottom: none;
  }

}
</style>
